import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'
import style from './Aside.module.scss'
import commonStyle from '../Costco.module.scss'
import Rating from './Rating'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

const Aside = () => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {!viewport.mobile && (
        <aside className={style.aside}>
          <div className={style.rowAlignBottom}>
            <div className={style.filterTitle}>{t('questions', 'ec', 'costco', 'filterResults')}</div>
            <EmptyLink color="#0060A9">
              <div className={style.clearAll}>{t('questions', 'ec', 'costco', 'clear')}</div>
            </EmptyLink>
          </div>
          <div className={style.lineHorizontal} />
          <div className={style.rowAlignBottom}>
            <div className={style.categoryTitle}>{t('questions', 'ec', 'costco', 'category')}</div>
            <EmptyLink color="#0060A9">
              <i className={`${commonStyle.costcoIcon} ${commonStyle.plus} ${style.plus}`} />
            </EmptyLink>
          </div>
          <div className={style.lineHorizontal} />
          <div className={style.location}>{t('questions', 'ec', 'costco', 'deliveryLoc')}</div>
          <div className={style.rowJustifyStart}>
            <div className={style.boxIcon} />
            <EmptyLink color="#0060A9">
              <div className={style.locationText}>{t('questions', 'ec', 'costco', 'myIndex')}</div>
            </EmptyLink>
          </div>
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>{t('questions', 'ec', 'costco', 'delivery')}</div>
          </div>
          <div className={style.location}>{t('questions', 'ec', 'costco', 'myWarehouse')}</div>
          <div className={style.rowJustifyStart}>
            <div className={style.locIcon} />
            <EmptyLink color="#0060A9">
              <div className={style.locationText}>{t('questions', 'ec', 'costco', 'myCity')}</div>
            </EmptyLink>
          </div>
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>{t('questions', 'ec', 'costco', 'buyInWarehouse')}</div>
          </div>
          <div className={style.lineHorizontal} />
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>{t('questions', 'ec', 'costco', 'outOf')}</div>
          </div>
          <div className={style.lineHorizontal} />
          <div className={style.rowAlignBottom}>
            <div className={style.categoryTitle}>{t('questions', 'ec', 'costco', 'price')}</div>
            <EmptyLink color="#0060A9">
              <i className={`${commonStyle.costcoIcon} ${commonStyle.minus} ${style.plus}`} />
            </EmptyLink>
          </div>
          <div className={style.lineHorizontal} />

          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>{t('questions', 'ec', 'costco', 'to25')}</div>
          </div>
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>{t('questions', 'ec', 'costco', 'to50')}</div>
          </div>
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>{t('questions', 'ec', 'costco', 'to100')}</div>
          </div>
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>{t('questions', 'ec', 'costco', 'to200')}</div>
          </div>
          <div className={style.lineHorizontal} />
          <div className={style.rowAlignBottom}>
            <div className={style.categoryTitle}>{t('questions', 'ec', 'costco', 'customerReviews')}</div>
            <EmptyLink color="#0060A9">
              <i className={`${commonStyle.costcoIcon} ${commonStyle.minus} ${style.plus}`} />
            </EmptyLink>
          </div>
          <div className={style.lineHorizontal} />
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>
              <div className={style.ratingItem}>
                <Rating rating={4} />
              </div>
              &nbsp;{t('questions', 'ec', 'costco', 'up4')}
            </div>
          </div>
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>
              <div className={style.ratingItem}>
                <Rating rating={3} />
              </div>
              &nbsp;{t('questions', 'ec', 'costco', 'up3')}
            </div>
          </div>
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>
              <div className={style.ratingItem}>
                <Rating rating={2} />
              </div>
              &nbsp;{t('questions', 'ec', 'costco', 'up2')}
            </div>
          </div>
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>
              <div className={style.ratingItem}>
                <Rating rating={1} />
              </div>
              &nbsp;{t('questions', 'ec', 'costco', 'up1')}
            </div>
          </div>
          <div className={style.lineHorizontal} />
          <div className={style.rowAlignBottom}>
            <div className={style.categoryTitle}>{t('questions', 'ec', 'costco', 'onlineOnly')}</div>
            <EmptyLink color="#0060A9">
              <i className={`${commonStyle.costcoIcon} ${commonStyle.minus} ${style.plus}`} />
            </EmptyLink>
          </div>
          <div className={style.lineHorizontal} />
          <div className={style.rowJustifyStart}>
            <EmptyLink color="#0060A9">
              <div className={style.checkbox} />
            </EmptyLink>
            <div className={style.checkboxText}>{t('questions', 'ec', 'costco', 'onlineOnly')}</div>
          </div>
          <div className={style.lineHorizontal} />
        </aside>
      )}
    </>
  )
}

export default Aside
